import Marquee from "react-fast-marquee";
import { useI18n } from "@/lib/i18n";

export default function EditorialMarquee() {
  const { t } = useI18n();
  return (
    <section className="relative py-16 md:py-24 border-y border-[#27272A] bg-[#050505] overflow-hidden" data-testid="marquee-section">
      <Marquee gradient={false} speed={40} pauseOnHover>
        {t.marquee.concat(t.marquee).map((word, i) => (
          <span
            key={i}
            className="font-display text-stroke text-[10vw] md:text-[8vw] leading-none tracking-tighter uppercase mx-8"
          >
            {word} <span className="text-[#E1FF00]">•</span>
          </span>
        ))}
      </Marquee>
    </section>
  );
}
